
import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const HomePage = lazy(() => import('../pages/home/page'));
const CatalogPage = lazy(() => import('../pages/catalog/page'));
const LunaMoonPage = lazy(() => import('../pages/catalog/luna-moon/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/catalogo',
    element: <CatalogPage />,
  },
  {
    path: '/catalogo/luna-moon',
    element: <LunaMoonPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
